import React, { useEffect, useState } from "react";
import { Button as UIButton } from "../../../components/ui";
import Question from "./Question";
import Loader from "../../../components/ui/Loader";
import apiService from "../../../services/apiService";
import { useToast } from "../../../context/ToastContext";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const ViewQuestions = () => {
  const taskId = useParams().id; //'68c292712653350dd1336169' //
  const navigate = useNavigate();
  let count = 45;
  //   const { showSuccess, showError, showInfo, showWarning } = useToast();

  useEffect(() => {
    apiService
      .request_old(`/i/ims/taskquestion/${taskId}`, { method: "GET" })
      .then((response) => {
        setQuestions(response.questionImages);
        count = response.questionImages.length;
      });
  }, [taskId]);

  const [questions, setQuestions] = useState(() =>
    Array.from({ length: count }, (_, i) => ({
      questionNum: i + 1,
      imagesArr: [],
    })),
  );
  const [loading, setLoading] = useState(false);

  // async function reOrder(images,questionNum){
  //     try{
  //         const updatedQuestions = questions.map(q =>
  //             q.questionNum === questionNum
  //                 ? { ...q, imagesArr: [...images] }
  //                 : q
  //         );

  //         setQuestions(updatedQuestions)

  //         const updtBody={
  //             questionImages:updatedQuestions
  //         }

  //         const res=await apiService.request_old(`/i/ims/taskquestion/${taskId}`,{method:'PUT',body:JSON.stringify(updtBody)})
  //         console.log(res)
  //         showSuccess('Reordered')
  //         return ;
  //     }
  //     catch(err){
  //         console.log(err)
  //         showError('Failed')
  //     }

  // }

  async function saveDB(uploadedUrls, questionNum, answer, flag) {
    //console.log(uploadedUrls,questionNum)

    let updatedQuestions;
    //if(flag==='reorder'){
    updatedQuestions = questions.map((q) =>
      q.questionNum === questionNum
        ? { questionNum, imagesArr: [...uploadedUrls], answer }
        : q,
    );
    //}
    // else{
    //     updatedQuestions = questions.map(q =>
    //         q.questionNum === questionNum
    //             ? { ...q, imagesArr: [...q.imagesArr,...uploadedUrls] }
    //             : q
    //     );
    // }

    setQuestions(updatedQuestions);
    const updtBody = {
      questionImages: updatedQuestions,
    };

    const res = await apiService.request_old(`/i/ims/taskquestion/${taskId}`, {
      method: "PUT",
      body: JSON.stringify(updtBody),
    });
    console.log(res);
    return;
  }

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Upload Questions</h1>
        <UIButton
          onClick={() => navigate(`/tools/task/view/${taskId}`)}
          variant="light"
          size="sm"
          icon={FaArrowLeft}
        >
          Back to Task
        </UIButton>
      </div>

      <div className="flex justify-end">
        <UIButton
          onClick={() =>
            window.open(
              `http://localhost:3000/tools/task/view/${taskId}/print`,
              "_blank",
              "noreferrer noopener",
            )
          } // navigate(`/tools/task/view/${taskId}/print`)}
          variant="primary"
          size="sm"
        >
          Print
        </UIButton>
      </div>

      {/* <div className="flex justify-end">
                <Button>
                    Save
                </Button>
            </div> */}

      <div className="flex flex-col bg-white border rounded-md p-2">
        <div>
          {loading ? (
            <Loader />
          ) : questions && questions.length > 0 ? (
            questions.map((question, i) => {
              return (
                <div>
                  <div>
                    <Question
                      question={question}
                      saveDB={saveDB}
                      taskId={taskId}
                    />
                  </div>
                </div>
              );
            })
          ) : null}
        </div>
      </div>
    </>
  );
};

export default ViewQuestions;
